import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';
function getToken() { return localStorage.getItem('admin_token'); }
async function request(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}`, ...options.headers }
  });
  return res.json();
}

export default function AdminsPage() {
  const [admins, setAdmins]     = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [msg, setMsg]           = useState('');
  const [form, setForm]         = useState({ name:'', email:'', password:'', role:'admin' });
  const [creating, setCreating] = useState(false);

  useEffect(() => { loadAdmins(); }, []);

  async function loadAdmins() {
    try {
      const data = await request('/admin/admins');
      setAdmins(data);
    } catch (err) { console.error(err); }
    setLoading(false);
  }

  async function handleCreate(e) {
    e.preventDefault();
    setCreating(true); setMsg('');
    try {
      const res = await request('/admin/admins', {
        method: 'POST',
        body: JSON.stringify(form)
      });
      if (res.error) throw new Error(res.error);
      setAdmins(prev => [...prev, res]);
      setForm({ name:'', email:'', password:'', role:'admin' });
      setShowForm(false);
      setMsg('Admin created successfully');
    } catch (err) { setMsg('Error: ' + err.message); }
    setCreating(false);
  }

  async function handleToggle(admin) {
    const path = admin.active ? 'deactivate' : 'activate';
    try {
      await request(`/admin/admins/${admin.id}/${path}`, { method: 'PUT' });
      setAdmins(prev => prev.map(a => a.id === admin.id ? {...a, active: !a.active} : a));
    } catch (err) { setMsg('Failed to update admin'); }
  }

  if (loading) return <div style={s.loading}>Loading...</div>;

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Admins</h1>
          <p style={s.subtitle}>Manage admin accounts</p>
        </div>
        <button style={s.newBtn} onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ New Admin'}
        </button>
      </div>

      {msg && <div style={{...s.msg, color: msg.includes('Error') ? '#FF3B30' : '#00C48C'}}>{msg}</div>}

      {showForm && (
        <div style={s.formCard}>
          <div style={s.formTitle}>Create new admin</div>
          <form onSubmit={handleCreate}>
            <div style={s.field}>
              <label style={s.label}>Full name</label>
              <input style={s.input} placeholder="Jane Smith"
                value={form.name} onChange={e => setForm({...form, name: e.target.value})} required/>
            </div>
            <div style={s.field}>
              <label style={s.label}>Email</label>
              <input style={s.input} type="email" placeholder="jane@thunderboltapps.com"
                value={form.email} onChange={e => setForm({...form, email: e.target.value})} required/>
            </div>
            <div style={s.field}>
              <label style={s.label}>Password</label>
              <input style={s.input} type="password" placeholder="At least 8 characters"
                value={form.password} onChange={e => setForm({...form, password: e.target.value})} required/>
            </div>
            <div style={s.field}>
              <label style={s.label}>Role</label>
              <select style={s.input} value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
                <option value="admin">Admin</option>
                <option value="super_admin">Super Admin</option>
              </select>
            </div>
            <button style={s.btn} type="submit" disabled={creating}>
              {creating ? 'Creating...' : 'Create admin'}
            </button>
          </form>
        </div>
      )}

      <div style={s.card}>
        {admins.map((admin, i) => (
          <div key={admin.id} style={{...s.row, borderBottom: i < admins.length-1 ? '1px solid #F5F5F7' : 'none'}}>
            <div style={s.avatar}>
              {admin.name.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)}
            </div>
            <div style={s.info}>
              <div style={s.name}>{admin.name}</div>
              <div style={s.email}>{admin.email}</div>
            </div>
            <div style={s.badges}>
              <span style={{...s.roleBadge, background: admin.role==='super_admin' ? '#FFF5E6' : '#EBF4FF', color: admin.role==='super_admin' ? '#FF9500' : '#007AFF'}}>
                {admin.role === 'super_admin' ? 'Super Admin' : 'Admin'}
              </span>
              <span style={{...s.statusBadge, background: admin.active ? '#E6FAF5' : '#F5F5F7', color: admin.active ? '#00C48C' : '#AEAEB2'}}>
                {admin.active ? 'Active' : 'Inactive'}
              </span>
            </div>
            <button
              style={{...s.toggleBtn, background: admin.active ? '#FFF0EF' : '#E6FAF5', color: admin.active ? '#FF3B30' : '#00C48C'}}
              onClick={() => handleToggle(admin)}>
              {admin.active ? 'Deactivate' : 'Activate'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const s = {
  loading:    {padding:40, color:'#6E6E73'},
  header:     {display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24},
  title:      {fontSize:28, fontWeight:700},
  subtitle:   {fontSize:14, color:'#6E6E73', marginTop:4},
  newBtn:     {padding:'10px 20px', background:'#1D1D1F', color:'#fff', border:'none', borderRadius:10, fontSize:14, fontWeight:600, cursor:'pointer'},
  msg:        {padding:'10px 14px', borderRadius:10, fontSize:13, fontWeight:500, marginBottom:16, background:'#F5F5F7'},
  formCard:   {background:'#fff', borderRadius:16, padding:24, marginBottom:24, boxShadow:'0 2px 20px rgba(0,0,0,0.06)'},
  formTitle:  {fontSize:16, fontWeight:600, marginBottom:16},
  field:      {marginBottom:14},
  label:      {display:'block', fontSize:13, fontWeight:500, color:'#6E6E73', marginBottom:6},
  input:      {width:'100%', padding:'11px 14px', border:'1.5px solid #F0F0F0', borderRadius:10, fontSize:14, background:'#FAFAFA', outline:'none', boxSizing:'border-box'},
  btn:        {width:'100%', padding:13, background:'#007AFF', color:'#fff', border:'none', borderRadius:10, fontSize:14, fontWeight:600, cursor:'pointer'},
  card:       {background:'#fff', borderRadius:16, overflow:'hidden', boxShadow:'0 2px 20px rgba(0,0,0,0.06)'},
  row:        {display:'flex', alignItems:'center', gap:14, padding:'16px 20px'},
  avatar:     {width:40, height:40, borderRadius:'50%', background:'#007AFF', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:600, flexShrink:0},
  info:       {flex:1},
  name:       {fontSize:14, fontWeight:600, color:'#1D1D1F'},
  email:      {fontSize:12, color:'#6E6E73', marginTop:2},
  badges:     {display:'flex', gap:6},
  roleBadge:  {fontSize:11, fontWeight:600, padding:'3px 8px', borderRadius:6},
  statusBadge:{fontSize:11, fontWeight:600, padding:'3px 8px', borderRadius:6},
  toggleBtn:  {padding:'7px 14px', border:'none', borderRadius:8, fontSize:12, fontWeight:600, cursor:'pointer'},
};
